import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CargoI, CargosI } from '../interfaces/list-cargo.interface';
import { CoreService } from 'src/app/shared/services/core-service.service';

@Injectable({providedIn: 'root'})
export class CargoService {

  private baseUrl: string = environment.baseUrlAuth;

  private http            = inject( HttpClient );
  private coreService     = inject( CoreService );


  getListCargo(): Observable<CargoI[]> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.get<CargoI[]>(`${this.baseUrl}/api/auth/cargos`, { headers })
      .pipe(
        // tap((response: CargoI[]) => console.log('response cargos:', response)),
        map((response: CargoI[]) => response),
        catchError(err => {
          this.coreService.openErrorSnackbar(`Error al obtener la lista de cargos: ${err.error.message}`, 'Ok');
          return throwError(() => err.error.message)
        }
      )
    );
  }


  getListCargoActive(): Observable<CargoI[]> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.get<CargoI[]>(`${this.baseUrl}/api/auth/cargos`, { headers })
      .pipe(
        // tap((response: CargoI[]) => console.log('response cargos:', response.filter((cargo: CargoI) => cargo.isActive === true))),
        map((response: CargoI[]) => response.filter((cargo: CargoI) => cargo.isActive === true)),
        catchError(err => {
          this.coreService.openErrorSnackbar(`Error al obtener la lista de cargos: ${err.error.message}`, 'Ok');
          return throwError(() => err.error.message)
        }
      )
    );
  }

  addCargo(body: CargosI): Observable<CargosI[]> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });
    return this.http.post<CargosI[]>(`${this.baseUrl}/api/auth/cargo`, body, { headers })
      .pipe(
        map((response: CargosI[]) => response),
        catchError(err => {
          this.coreService.openErrorSnackbar(`Error al adicionar el cargo: ${err.error.message}`, 'Ok');
          return throwError(() => err.error.message)
        })
      );
  }


  updateCargo(body: CargosI): Observable<CargosI[]> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });
    return this.http.put<CargosI[]>(`${this.baseUrl}/api/auth/cargo`, body, { headers })
      .pipe(
        map((response: CargosI[]) => response),
        catchError(err => {
          this.coreService.openErrorSnackbar(`Error al actualizar el cargo: ${err.error.message}`, 'Ok');
          return throwError(() => err.error.message)
        })
      );
  }


}
